import PropTypes from 'prop-types';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import Iconify from '../../../components/Iconify';
import KycSummaryCard from './KycSummaryCard';

export default function ManageUserDialogTabs({ currentTab, kycStatus, onChange, tabs }) {
  return (
    <Paper
      square
      elevation={0}
      sx={{
        width: { xs: 80, md: 220 },
        borderRight: (theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: 'background.paper',
      }}
    >
      <KycSummaryCard kycStatus={kycStatus} />

      <Tabs
        orientation="vertical"
        value={currentTab}
        onChange={onChange}
        sx={{
          px: 0.75,
          py: 1,
          '& .MuiTabs-indicator': {
            left: 0,
            width: 3,
            borderRadius: 999,
          },
          minHeight: 'auto',
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            icon={<Iconify icon={tab.icon} width={18} height={18} />}
            iconPosition="start"
            label={
              <Box sx={{ display: { xs: 'none', md: 'block' }, textAlign: 'left', width: '100%' }}>
                {tab.label}
              </Box>
            }
            sx={{
              minHeight: 40,
              mb: 0.5,
              borderRadius: 1.75,
              alignItems: 'center',
              justifyContent: { xs: 'center', md: 'flex-start' },
              px: { xs: 0.5, md: 1.25 },
              fontSize: 13,
              '&.Mui-selected': {
                bgcolor: 'action.selected',
              },
            }}
          />
        ))}
      </Tabs>
    </Paper>
  );
}

ManageUserDialogTabs.propTypes = {
  currentTab: PropTypes.string.isRequired,
  kycStatus: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  tabs: PropTypes.array.isRequired,
};
